<h1 class="pricing_title">
  <ng-content></ng-content>
</h1>
<p class="pricing_subtitle">
  Your company size - {{usersCount$ | async}} members.
</p>
